interface Props {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: "primary" | "secondary" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
  className?: string;
  type?: "button" | "submit";
}

const variants = {
  primary: `
    bg-gradient-to-r from-gruvbox-yellow to-gruvbox-orange/80
    text-gruvbox-bg font-bold
    shadow-[0_0_24px_rgba(251,191,36,0.18)]
    hover:shadow-[0_0_40px_rgba(251,191,36,0.30)]
    hover:brightness-110
    active:scale-[0.98]
    border border-gruvbox-yellow/40
  `,
  secondary: `
    glass
    text-gruvbox-fg1 font-medium
    hover:border-gruvbox-yellow/30
    hover:text-gruvbox-fg
    hover:shadow-[0_0_20px_rgba(251,191,36,0.06)]
    active:scale-[0.98]
  `,
  ghost: `
    text-gruvbox-fg1 font-medium
    border border-transparent
    hover:glass-subtle
    active:scale-[0.98]
  `,
  danger: `
    glass
    text-gruvbox-red font-medium
    border-gruvbox-red/20
    hover:border-gruvbox-red/40
    hover:shadow-[0_0_20px_rgba(248,113,113,0.08)]
    active:scale-[0.98]
  `,
};

const sizes = {
  sm: "px-md py-sm text-xs rounded-lg",
  md: "px-xl py-md text-sm rounded-lg",
  lg: "px-3xl py-md text-sm rounded-xl",
};

export default function CosmicButton({
  children, onClick, disabled, variant = "primary", size = "md", className = "", type = "button",
}: Props) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center justify-center gap-md
        transition-all duration-200 ease-out
        disabled:opacity-40 disabled:pointer-events-none
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
    >
      {children}
    </button>
  );
}
